import Vue from 'vue';
import { moment } from '../../../../vendor/moment';

/**
 * **Vue Filter** A filter to format date strings using Moment.js
 * @function momentFormat
 * @param {string} value - Date string to be formatted
 * @param {string} [format="MM/DD/YYYY hh:mm"] - Format string to be used,
 * see [moment.js formatting documentation]{@link https://momentjs.com/docs/#/displaying/format/}
 * @returns {string} A date string in the requested or default format
 * @example
 * <span class="myDate">{{ event.startDate |  momentFormat('h:mm a') }}</span>
 */
Vue.filter('momentFormat', function (value, format) {
    if (!value) {
        return '';
    }

    format = format ? format : 'MM/DD/YYYY hh:mm';

    return moment(String(value)).format(format);
});
